export const SUPPORTED_AUTH_PROVIDERS = ['apple', 'google'] as const;

export const AUTH_PROVIDER_TO_LABEL: Record<(typeof SUPPORTED_AUTH_PROVIDERS)[number], string> = {
  apple: 'Apple',
  google: 'Google',
};
